import { BUMMER_SUBMODULES } from "@/constants";
import { LOCAL } from "@/store/mutations";
import { priorityShuffle } from "@/lib/random";
import collection from "@/store/dynamic-collection.store-partial";
import bummerModule from "./single.store";

const { SET_AVAILABLE_BUMMERS } = LOCAL;


export default {
	namespaced: true,
	modules: {
		collection,
		available: [],
	},
	getters: {
		active: (state, getters) => getters.array.filter((bummer) => bummer.active),
		wheel: (state) => state.available.reduce(
			(sections, id) => [...sections, {
				id,
				model: state.collection.items[id].model,
				symbol: state.collection.items[id].insurance_type || state.collection.items[id].model,
			}], []
		),
	},
	actions: {
		configureApp: {
			root: true,
			async handler({ dispatch }, configData) {
				await dispatch("collection/populate", {
					items: configData.bummers,
					path: ["game", "bummers", "active"],
					module: bummerModule,
				});
			},
		},
		activate({ dispatch, getters }, bummer) {
			const { model } = getters.getById(bummer.id);
			dispatch("collection/activate", bummer);
			this.registerModule(["game", "bummers", "active", model], BUMMER_SUBMODULES[model]);
		},
		deactivate({ dispatch, rootState }, bummer) {
			dispatch("collection/deactivate", {
				path: ["game", "bummers", "active"],
				state: rootState.global.api.data.bummers[bummer.id],
			});
		},
		prepare({ commit, rootGetters }, available) {
			const shuffled = priorityShuffle(available, rootGetters["game/rounds/active/bummerCount"]);
			commit(SET_AVAILABLE_BUMMERS, shuffled);
		},
	},
	mutations: {
		[SET_AVAILABLE_BUMMERS](state, bummers) {
			state.available = [...bummers];
		},
	},
};
